import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export const PackChatRefreshError = ({ onRetry }: { onRetry?: () => void }) => (
  <Stack className="w-full" align="start" gap={1} role="alert">
    <Text variant="caption" tone="muted">
      Could not refresh the conversation. Your draft is saved here. New messages
      may be missing.
    </Text>
    {onRetry && (
      <Button variant="secondary" size="sm" onClick={onRetry}>
        Try again
      </Button>
    )}
  </Stack>
);
